import React, {useState, useEffect} from 'react'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import { LATEST_AVAILABLE_YEAR, EARLIEST_AVAILABLE_YEAR } from '../../constants';



function SelectDropdown(props) {


  const [years, setYears] = useState([])
  const[selectedTimeline, setSelectedTimeline] = useState(1940)
  const data = require('./../../assets/data/data.json') || props.gameData
  const uniqueYears = [...new Set(data.map(entry => entry.Election))];


  useEffect(() => {
    let newYears = []
    for (let year = EARLIEST_AVAILABLE_YEAR; year <= LATEST_AVAILABLE_YEAR; year += 4) {
        newYears.push(year)
    }
    setYears(newYears)
  }, [])

  function handleChange(e){
    setSelectedTimeline(e.target.value)
    props.handleChange(e.target.value)
  }

  return (
    <div>
      <FormControl sx={{ m: 1, minWidth: 120 }}>
        <InputLabel id="demo-simple-select-label">Year</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={selectedTimeline}
          label="Year"
          onChange={handleChange}
        >
          {
            uniqueYears.sort().map((year, index) => {
              return (
                <MenuItem key={index} value={year}>{year}</MenuItem>
              )
            }
          )
          }
        </Select>
      </FormControl>
    </div>
  )
}

export default SelectDropdown